import { Panel } from '@/ui/composites/Panel';
import { settingsPanelSurfaceSx } from '@/ui/composites/settingsPageTypographySx';
import type { FormCardProps } from '@/ui/composites/FormCard';
import type { ReactElement, ReactNode } from 'react';

type SettingsSectionPanelProps = {
  title?: string | null;
  actions?: ReactNode;
  children: ReactNode;
  titleSlot?: ReactNode;
  sx?: FormCardProps['sx'];
};

export const SettingsSectionPanel = ({
  title,
  actions,
  children,
  titleSlot,
  sx,
}: SettingsSectionPanelProps): ReactElement => {
  const resolvedSx = sx
    ? ([settingsPanelSurfaceSx, ...(Array.isArray(sx) ? sx : [sx])] as FormCardProps['sx'])
    : settingsPanelSurfaceSx;

  return (
    <Panel
      title={title ?? undefined}
      actions={actions}
      titleSlot={titleSlot}
      footerGap="xs"
      surfaceVariant="settings"
      sx={resolvedSx}
    >
      {children}
    </Panel>
  );
};
